import { render, staticRenderFns } from "./stepSide.vue?vue&type=template&id=4afd59db&scoped=true&"
import script from "./stepSide.vue?vue&type=script&lang=js&"
export * from "./stepSide.vue?vue&type=script&lang=js&"
import style0 from "./stepSide.vue?vue&type=style&index=0&id=4afd59db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd59db",
  null
  
)

export default component.exports